export var UserInputType = /*#__PURE__*/function (UserInputType) {
  UserInputType["NUMBER"] = "NUMBER";
  UserInputType["TEXT"] = "TEXT";
  UserInputType["BOOLEAN"] = "BOOLEAN";
  UserInputType["DROPDOWN"] = "DROPDOWN";
  UserInputType["PARAGRAPH"] = "PARAGRAPH";
  return UserInputType;
}({});
export var CORE_PROJECT = 'business';
export var SOFTWARE_PROJECT = 'software';
export var SERVICE_DESK_PROJECT = 'service_desk';
export var PRODUCT_DISCOVERY_PROJECT = 'product_discovery';